import { render, staticRenderFns } from "./MatterStopCustomsForm.vue?vue&type=template&id=570e4ea8&"
import script from "./MatterStopCustomsForm.vue?vue&type=script&lang=js&"
export * from "./MatterStopCustomsForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterStopCustomsForm.vue?vue&type=style&index=0&id=570e4ea8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports